import React from "react";
import { Grid, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

type StatisticsProps = {
  tenders: number,
  calls: number,
  financeSupport: number,
  employed: number,
  text1: string,
  text2: string,
  text3: string,
  text4: string,
}

const Statistics: ({tenders, calls, financeSupport, employed, text1, text2, text3, text4}: StatisticsProps) => JSX.Element = ({ tenders, calls, financeSupport, employed, text1, text2, text3, text4 }: StatisticsProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const breakpoints = useMediaQuery(theme.breakpoints.up("sm"));

  const statistics = [
    {
      itemNumber: 1,
      count: tenders,
      text: text1,
    },
    {
      itemNumber: 2,
      count: calls,
      text: text2,
    },
    {
      itemNumber: 3,
      count: financeSupport,
      text: text3,
    },
    {
      itemNumber: 4,
      count: employed,
      text: text4,
    },
  ];

  return (
    <Grid
      container
      // spacing={6}
      sx={{
        backgroundColor: "secondary.main",
        borderRadius: "15px",
        my: theme.spacing(16),
      }}
    >
      {statistics.map((item) => (
        <Grid
          item
          display="flex"
          justifyContent="center"
          my={breakpoints ? 10 : 6}
          color="white"
          xs={12}
          sm={6}
          lg={3}
          key={item.itemNumber}
          padding="0 1rem"
        >
          <Typography variant="h2" fontWeight={700} color="white" fontSize="60px">
            {item.count}
          </Typography>
          <Box sx={{ ml: 2 }}>
            <Typography variant="h6" sx={{ opacity: "70%", fontSize: '1.1rem' }}>
              {item.text}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Statistics;
